import script from "./BidManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./BidManagement.vue?vue&type=script&setup=true&lang=js"

import "./BidManagement.vue?vue&type=style&index=0&id=06d9f72b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06d9f72b"]])

export default __exports__